<template>
  <div class="saleLogin">
    <van-form @submit="onSubmit">
      <van-field
        v-model="patientId"
        name="patientId"
        label="受试者id"
        placeholder="受试者id"
        :rules="[{ required: true, message: '请填写受试者id' }]"
      />
      <van-field
        v-model="patientName"
        name="patientName"
        label="用户名"
        placeholder="用户名"
        :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field name="radio" label="性别">
        <template #input>
          <van-radio-group v-model="radio" direction="horizontal">
            <van-radio name="1">男</van-radio>
            <van-radio name="2">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="identity"
        type="identity"
        name="identity"
        label="身份证"
        placeholder="身份证"
        :rules="[{ required: true, message: '请填写身份证', },{
            pattern:
              /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '请输入正确格式',
            trigger: 'onBlur',
        },
        ]"
      />
      <van-field
        v-model="tel"
        type="tel"
        name="tel"
        label="手机号码"
        placeholder="手机号码"
        :rules="[{ required: true, message: '请填写手机号码' }, {
            pattern: /^1[3456789]\d{9}$/,
            message: '手机号码格式错误！',
            trigger: 'onBlur',
          },]"
      />
      <van-field
        readonly
        clickable
        label="受试日期"
        name="firstDate"
        :value="firstDate"
        placeholder="点击选择受试日期"
        @click="showCalendar = true"
      />
      <van-calendar v-model="showCalendar" :min-date="minDate"  @confirm="onConfirm" color="#208FE3" />
      <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from 'vue';
import { Dialog, Button, Popup as VanPopup } from 'vant';
import { RadioGroup, Radio } from 'vant';
import { Calendar } from 'vant';
import { Field } from 'vant';
import { Form } from 'vant';
import request from '../../services/doctor';
import saleLogin from '../../services/saleLogin';
import { Toast as VanToast } from 'vant';
Vue.use(Calendar);
Vue.use(Radio);
Vue.use(RadioGroup);
export default {
  name: 'addPenant',
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
    Button,
    VanPopup,
    VanToast,
    [Form.name]: Form
  },
  data() {
    return {
      patientId: undefined,
      patientName: undefined,
      radio: '1',
      tel: undefined,
      identity: undefined,
      showCalendar: false,
      firstDate: undefined,
      doctorId: '',
      hospitalId: '',
      minDate: new Date(2010, 0, 1),
    };
  },

  methods: {
    
    onConfirm(date) {
      this.firstDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
      this.showCalendar = false;
    },
    onSubmit(values) {
      const params = {
        patientId: values.patientId,
        patientName: values.patientName,
        patientSex: values.radio,
        patientCard: values.identity,
        patientMobile: values.tel,
        enrollmentDate: values.firstDate,
        doctorId: this.$route.query.doctorId,
        hospitalId: this.$route.query.hospitalId
      };

      saleLogin.saveIGU(params).then(res => {
        console.log(params);
        console.log(res);
        if (res.data.code == 200) {
       
            VanToast.success('保存成功');

          this.$router.push({
            name: 'IGUList',
            query: {
              doctorId: this.$route.query.doctorId,
              hospitalId: this.$route.query.hospitalId
            }
          });
        } else if (res.data.code == 100) {
            this.$toast({
            message:res.data.msg,
          })
        } else {
          this.$toast({
            message:res.data.msg,
          })
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
body {
  width: 100%;
}
</style>
